import { render, staticRenderFns } from "./DouyinConfig.vue?vue&type=template&id=042f3246&scoped=true"
import script from "./DouyinConfig.vue?vue&type=script&lang=js"
export * from "./DouyinConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f3246",
  null
  
)

export default component.exports